import { Button, Popover, Stack } from '@mui/material';
import { useState } from 'react';

export const SummaryTransportation = ({ transportationEventFormData }) => {
  const {
    transportation: {
      status,
      beginDate,
      endDate,
      driver,
      vehicle,
      totalDistance,
      totalDuration,
      startPoint,
      endPoint,
    },
  } = transportationEventFormData;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="flex justify-center items-center w-full">
      <Button
        aria-describedby={id}
        variant="outlined"
        onClick={handleClick}
        className="w-full"
      >
        GÖREV BİLGİLERİ
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Stack className="p-2">
          <Stack style={{ fontSize: '13px' }} spacing={1}>
            <p>
              <span style={{ fontWeight: 'bold' }}>Sürücü Adı</span>:{' '}
              {driver?.id}
            </p>
            <p>
              <span style={{ fontWeight: 'bold' }}>Araç Plakası</span>:{' '}
              {vehicle?.id}
            </p>
            <p>
              <span style={{ fontWeight: 'bold' }}>Durum</span>:{' '}
              {status === 'COMPLETED' ? 'TAMAMLANDI' : 'AKTİF'}
            </p>
            <p>
              <span style={{ fontWeight: 'bold' }}>Başlangıç Zamanı</span>:{' '}
              {new Date(beginDate).toLocaleString('tr')}
            </p>
            <p>
              <span style={{ fontWeight: 'bold' }}>Bitiş Zamanı</span>:{' '}
              {new Date(endDate).toLocaleString('tr')}
            </p>
            <p>
              <span style={{ fontWeight: 'bold' }}>Toplam Mesafe</span>:{' '}
              {Math.round(totalDistance / 1000)}km
            </p>
            <p>
              <span style={{ fontWeight: 'bold' }}>Toplam Zaman</span>:{' '}
              {Math.round(totalDuration / 60)}dk
            </p>
            <p>
              <span style={{ fontWeight: 'bold' }}>Başlangıç Noktası</span>:{' '}
              {startPoint}
            </p>
            <p>
              <span style={{ fontWeight: 'bold' }}>Bitiş Noktası</span>:{' '}
              {endPoint}
            </p>
          </Stack>
        </Stack>
      </Popover>
    </div>
  );
};
